import { defineStore } from "pinia";
import type Notification from "@/interfaces/Notifications/Notification";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    notification: undefined as Notification | undefined,
  }),
  actions: {
    setNotification(notification: Notification | undefined) {
      this.notification = notification ? { ...notification } : undefined;
    },
    clearNotification() {
      this.notification = undefined;
    },
  },
});
